import {Component, inject} from '@angular/core';
import {MatListItem, MatNavList} from '@angular/material/list';
import {MatIcon} from '@angular/material/icon';
import {RouterLink} from '@angular/router';
import {TranslocoPipe} from '@jsverse/transloco';
import {DrawerService} from '../../../services/drawer-service';

@Component({
  selector: 'app-navbar',
  imports: [
    MatIcon,
    MatListItem,
    MatNavList,
    RouterLink,
    TranslocoPipe
  ],
  templateUrl: './navbar.html',
  styleUrl: './navbar.scss',
})
export class Navbar {
  public readonly drawerService = inject(DrawerService);

  onClick(): void {
    this.drawerService.state.set(false);
  }
}
